import { apiRequest } from '../../services/apiClient';

export interface WowpressProductSummary {
  prodno: number;
  name: string;
  pathname: string;
  useyn: 'Y' | 'N';
  prdclass?: 'P' | 'S';
}

export interface WowpressSizeOption {
  sizeno: number;
  sizename: string;
  width: number | null;
  height: number | null;
  non_standard: boolean;
}

export interface WowpressPaperOption {
  paperno: number;
  papername: string;
  papergroup?: string;
  pgram?: number;
}

interface WowpressReqPrsJob {
  jobno: number;
  jobname?: string;
}

export interface WowpressColorOption {
  colorno: number;
  colorname: string;
  req_prsjob?: WowpressReqPrsJob[] | null;
}

export interface WowpressColorPage {
  pagecd: number; // 1: 전면, 2: 후면
  type: string;
  colorlist: WowpressColorOption[];
}

export interface WowpressAwkJobOption {
  jobno: number;
  jobname: string;
}

// select: 선택사항(단일), checkbox: 선택사항(복수), radio: 필수사항(단일)
export interface WowpressAwkSubGroup {
  jobgroupno: number;
  jobgroup: string;
  type: 'radio' | 'select' | 'checkbox';
  awkjoblist: WowpressAwkJobOption[];
}

export interface WowpressAwkGroup {
  covercd: number;
  type: 'radio' | 'select' | 'checkbox';
  jobgrouplist: WowpressAwkSubGroup[];
}

export interface WowpressOrdQtyOption {
  sizeno: number | null;
  ordqtymin: number | null;
  ordqtymax: number | null;
  ordqtyinterval: number | null;
  ordqtylist: number[] | null;
}

export interface WowpressProductDetail {
  prodno: number;
  prodname: string;
  unit: string;
  coverinfo: { covercd: number; covername: string }[];
  ordqty: WowpressOrdQtyOption[];
  sizeinfo: { covercd: number; sizelist: WowpressSizeOption[] }[];
  paperinfo: { covercd: number; paperlist: WowpressPaperOption[] }[];
  colorinfo: { covercd: number; pagelist: WowpressColorPage[] }[];
  awkjobinfo: WowpressAwkGroup[];
}

export interface WowpressPriceResult {
  status: number | string;
  errmsg?: string;
  ordqty?: number;
  ordcnt?: number;
  exitday?: number;
  exitdate?: string;
  ordcost_price?: number;
  ordcost_dc?: number;
  ordcost_sup?: number;
  ordcost_tax?: number;
  ordcost_bill?: number;
}

export interface WowpressPriceRequestJob {
  jobno: number;
  covercd: number;
  sizeno?: number;
  wsize?: number | null;
  hsize?: number | null;
  jobqty?: string;
  paperno?: number;
  colorno0?: number;
  colorno0add?: string;
}

export interface WowpressAwkJobRequest {
  jobno: number;
  covercd: number;
}

export function fetchWowpressProducts(): Promise<WowpressProductSummary[]> {
  return apiRequest('/api/wowpress/products');
}

export function fetchWowpressProductDetail(prodno: number): Promise<WowpressProductDetail> {
  return apiRequest(`/api/wowpress/products/${prodno}`);
}

export function fetchWowpressPrice(
  prodno: number,
  payload: {
    ordqty: string;
    ordcnt: string;
    ordtitle: string;
    prsjob: WowpressPriceRequestJob[];
    awkjob: WowpressAwkJobRequest[];
  },
): Promise<WowpressPriceResult> {
  return apiRequest(`/api/wowpress/products/${prodno}/price`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export interface WowpressProductInfo {
  name: string | null;
  unit: string | null;
  // 공급처가 제공하는 상품설명(HTML일 수 있음)
  description: string | null;
}

export function fetchWowpressProductInfo(prodno: number): Promise<WowpressProductInfo> {
  return apiRequest<WowpressProductInfo>(`/api/wowpress/products/${prodno}/info`);
}
